import { c as _c } from "react/compiler-runtime";
import { LocaleEnum } from '@systemeio/ui';
import { AUTOMATION_RULES_FILTER_API } from 'modules/automation-rules/api/automation-rules-api';
import { BlogEntityEnum, BlogPageEnum } from 'modules/automation-rules/enums/automation-rule-enum';
import { AutomationRuleTriggersDataEnum, AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { getShouldFetchTriggers } from 'modules/automation-rules/triggers/utils/get-should-fetch-triggers';
import { AutomationRuleFilterInterface, BlogEntityDataInterface, FilterBaseApiInterface, FilterBlogApiInterface, FilterEmailApiInterface, FilterEmailLinkApiInterface } from 'modules/automation-rules/types/automation-rule-filter-interface';
import { AutomationRuleBaseDataInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { geDataFromApiData, getBlogEntityData, getData } from 'modules/automation-rules/utils/get-filter-data';
import { useMyEvents } from 'modules/calendar/events/hooks/use-my-events';
import { useCourseBundlesListAll } from 'modules/courses/bundles/hooks/use-course-bundlies-list-all';
import { coursesDependencies } from 'modules/courses/constants/courses-dependencies';
import { useStoreOptinItemsList } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-optin-items-list';
import { useStoreWithOptinItemsList } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-with-optin-items-list';
import { useTagsAll } from 'modules/tags/hooks/use-tags-all';
import { Dispatch, SetStateAction, useState } from 'react';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
import { getClickedLinkCaption, getClickedLinkCustomCaption } from '../components/edit-triggers/components/trigger-email-link-item/get-clicked-link-name';
import { useCampaignsList } from 'modules/campaigns/hooks/use-campaigns-list';
import { useWebsiteListAll } from 'modules/websites/hooks/use-website-list-all';
import { useWebsitePageListAll } from 'modules/websites/hooks/use-website-page-list-all';
import { FormSelectDataWithGroupType } from 'shared/components/form-select/form-select-with-groups';
export interface TriggersDataInterface {
  tagData?: AutomationRuleBaseDataInterface[];
  campaignData?: AutomationRuleBaseDataInterface[];
  blogData?: AutomationRuleBaseDataInterface[];
  blogEntityData?: BlogEntityDataInterface;
  blogPagesData?: AutomationRuleBaseDataInterface[];
  blogPostsData?: AutomationRuleBaseDataInterface[];
  funnelsFormSubscribeData?: AutomationRuleBaseDataInterface[];
  funnelStepsFormSubscribeData?: AutomationRuleBaseDataInterface[];
  funnelsNewSaleData?: AutomationRuleBaseDataInterface[];
  funnelStepsNewSaleData?: AutomationRuleBaseDataInterface[];
  funnelsSaleCanceledData?: AutomationRuleBaseDataInterface[];
  funnelStepsSaleCanceledData?: AutomationRuleBaseDataInterface[];
  funnelsPageVisitedData?: AutomationRuleBaseDataInterface[];
  funnelStepsPageVisitedData?: AutomationRuleBaseDataInterface[];
  funnelsWebinarData?: AutomationRuleBaseDataInterface[];
  webinarData?: AutomationRuleBaseDataInterface[];
  courseData?: AutomationRuleBaseDataInterface[];
  moduleData?: AutomationRuleBaseDataInterface[];
  lectureData?: AutomationRuleBaseDataInterface[];
  courseBundleData?: AutomationRuleBaseDataInterface[];
  communityData?: AutomationRuleBaseDataInterface[];
  emailData?: AutomationRuleBaseDataInterface[];
  emailLinksData?: AutomationRuleBaseDataInterface[];
  funnelsSubscriptionPaymentFailedData?: AutomationRuleBaseDataInterface[];
  funnelStepsSubscriptionPaymentFailedData?: AutomationRuleBaseDataInterface[];
  digitalStoresData?: AutomationRuleBaseDataInterface[];
  digitalStoreOptInsData?: AutomationRuleBaseDataInterface[];
  eventsData?: AutomationRuleBaseDataInterface[];
  websiteData?: AutomationRuleBaseDataInterface[];
  websitePageData?: FormSelectDataWithGroupType<number, LocaleEnum>[];
}
export function useTriggersData(triggerItem) {
  const $ = _c(184);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getShouldFetchTriggers();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [shouldFetch, setShouldFetch] = useState(t0);
  const {
    trigger,
    formSubscribeFunnelId,
    pageVisitedFunnelId,
    newSaleFunnelId,
    cancelSaleFunnelId,
    blogId,
    blogEntity,
    webinarFunnelId,
    triggerCourseId,
    triggerModuleId,
    subscriptionFailedFunnelId,
    triggerMailingId,
    triggerDigitalStoreId,
    triggerWebsiteId
  } = triggerItem;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: baseFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: blogFetcher
  } = useFetch(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      method: RequestMethodsEnum.get
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    fetcher: emailFetcher
  } = useFetch(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      method: RequestMethodsEnum.get
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    fetcher: emailLinkFetcher
  } = useFetch(t4);
  const {
    tags
  } = useTagsAll(shouldFetch.tag);
  let t5;
  if ($[5] !== shouldFetch.blog_page_form_subscribed || $[6] !== user) {
    t5 = () => {
      if (user && shouldFetch.blog_page_form_subscribed) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/blog`;
      }
      return null;
    };
    $[5] = shouldFetch.blog_page_form_subscribed;
    $[6] = user;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data: blogs
  } = useSWR(t5, blogFetcher);
  let t6;
  if ($[8] !== blogEntity || $[9] !== blogId || $[10] !== shouldFetch.blog_page_form_subscribed_page || $[11] !== user) {
    t6 = () => {
      if (user && shouldFetch.blog_page_form_subscribed_page && blogId && (blogEntity === BlogEntityEnum.blog_page || blogEntity === BlogPageEnum.blog_static || blogEntity === BlogPageEnum.blog_home || blogEntity === BlogPageEnum.blog_post_listing || blogEntity === BlogPageEnum.blog_search)) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/blog-pages/${blogId}/page`;
      }
      return null;
    };
    $[8] = blogEntity;
    $[9] = blogId;
    $[10] = shouldFetch.blog_page_form_subscribed_page;
    $[11] = user;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const {
    data: blogPages
  } = useSWR(t6, baseFetcher);
  let t7;
  if ($[13] !== blogEntity || $[14] !== blogId || $[15] !== shouldFetch.blog_page_form_subscribed_post || $[16] !== user) {
    t7 = () => {
      if (user && shouldFetch.blog_page_form_subscribed_post && blogId && blogEntity === BlogEntityEnum.blog_post_body) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/blog-pages/${blogId}/post`;
      }
      return null;
    };
    $[13] = blogEntity;
    $[14] = blogId;
    $[15] = shouldFetch.blog_page_form_subscribed_post;
    $[16] = user;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const {
    data: blogPosts
  } = useSWR(t7, baseFetcher);
  let t8;
  if ($[18] !== shouldFetch.form_subscribed || $[19] !== trigger || $[20] !== user) {
    t8 = () => {
      if (user && shouldFetch.form_subscribed && trigger === AutomationRuleTriggersEnum.form_subscribed) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel/${trigger}`;
      }
      return null;
    };
    $[18] = shouldFetch.form_subscribed;
    $[19] = trigger;
    $[20] = user;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const {
    data: funnelsFormSubscribe
  } = useSWR(t8, baseFetcher);
  let t9;
  if ($[22] !== formSubscribeFunnelId || $[23] !== shouldFetch.form_subscribed_funnel_step || $[24] !== trigger || $[25] !== user) {
    t9 = () => {
      if (user && shouldFetch.form_subscribed_funnel_step && formSubscribeFunnelId && trigger === AutomationRuleTriggersEnum.form_subscribed) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel-step/${trigger}/${formSubscribeFunnelId}`;
      }
      return null;
    };
    $[22] = formSubscribeFunnelId;
    $[23] = shouldFetch.form_subscribed_funnel_step;
    $[24] = trigger;
    $[25] = user;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const {
    data: funnelStepsFormSubscribe
  } = useSWR(t9, baseFetcher);
  let t10;
  if ($[27] !== shouldFetch.new_sale || $[28] !== trigger || $[29] !== user) {
    t10 = () => {
      if (user && shouldFetch.new_sale && trigger === AutomationRuleTriggersEnum.new_sale) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel/${trigger}`;
      }
      return null;
    };
    $[27] = shouldFetch.new_sale;
    $[28] = trigger;
    $[29] = user;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  const {
    data: funnelsNewSale
  } = useSWR(t10, baseFetcher);
  let t11;
  if ($[31] !== newSaleFunnelId || $[32] !== shouldFetch.new_sale_funnel_step || $[33] !== trigger || $[34] !== user) {
    t11 = () => {
      if (user && shouldFetch.new_sale_funnel_step && newSaleFunnelId && trigger === AutomationRuleTriggersEnum.new_sale) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel-step/${trigger}/${newSaleFunnelId}`;
      }
      return null;
    };
    $[31] = newSaleFunnelId;
    $[32] = shouldFetch.new_sale_funnel_step;
    $[33] = trigger;
    $[34] = user;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  const {
    data: funnelStepsNewSale
  } = useSWR(t11, baseFetcher);
  let t12;
  if ($[36] !== shouldFetch.sale_canceled || $[37] !== trigger || $[38] !== user) {
    t12 = () => {
      if (user && shouldFetch.sale_canceled && trigger === AutomationRuleTriggersEnum.sale_canceled) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel/${trigger}`;
      }
      return null;
    };
    $[36] = shouldFetch.sale_canceled;
    $[37] = trigger;
    $[38] = user;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  const {
    data: funnelsSaleCanceled
  } = useSWR(t12, baseFetcher);
  let t13;
  if ($[40] !== cancelSaleFunnelId || $[41] !== shouldFetch.sale_canceled_funnel_step || $[42] !== trigger || $[43] !== user) {
    t13 = () => {
      if (user && shouldFetch.sale_canceled_funnel_step && cancelSaleFunnelId && trigger === AutomationRuleTriggersEnum.sale_canceled) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel-step/${trigger}/${cancelSaleFunnelId}`;
      }
      return null;
    };
    $[40] = cancelSaleFunnelId;
    $[41] = shouldFetch.sale_canceled_funnel_step;
    $[42] = trigger;
    $[43] = user;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  const {
    data: funnelStepsSaleCanceled
  } = useSWR(t13, baseFetcher);
  let t14;
  if ($[45] !== shouldFetch.page_visited || $[46] !== trigger || $[47] !== user) {
    t14 = () => {
      if (user && shouldFetch.page_visited && trigger === AutomationRuleTriggersEnum.page_visited) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel/${trigger}`;
      }
      return null;
    };
    $[45] = shouldFetch.page_visited;
    $[46] = trigger;
    $[47] = user;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  const {
    data: funnelsPageVisited
  } = useSWR(t14, baseFetcher);
  let t15;
  if ($[49] !== pageVisitedFunnelId || $[50] !== shouldFetch.page_visited_funnel_step || $[51] !== trigger || $[52] !== user) {
    t15 = () => {
      if (user && shouldFetch.page_visited_funnel_step && pageVisitedFunnelId && trigger === AutomationRuleTriggersEnum.page_visited) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel-step/${trigger}/${pageVisitedFunnelId}`;
      }
      return null;
    };
    $[49] = pageVisitedFunnelId;
    $[50] = shouldFetch.page_visited_funnel_step;
    $[51] = trigger;
    $[52] = user;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  const {
    data: funnelStepsPageVisited
  } = useSWR(t15, baseFetcher);
  let t16;
  if ($[54] !== shouldFetch.subscription_payment_failed || $[55] !== trigger || $[56] !== user) {
    t16 = () => {
      if (user && shouldFetch.subscription_payment_failed && trigger === AutomationRuleTriggersEnum.subscription_payment_failed) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel/${trigger}`;
      }
      return null;
    };
    $[54] = shouldFetch.subscription_payment_failed;
    $[55] = trigger;
    $[56] = user;
    $[57] = t16;
  } else {
    t16 = $[57];
  }
  const {
    data: funnelsSubscriptionPaymentFailed
  } = useSWR(t16, baseFetcher);
  let t17;
  if ($[58] !== shouldFetch.subscription_payment_failed_funnel_step || $[59] !== subscriptionFailedFunnelId || $[60] !== trigger || $[61] !== user) {
    t17 = () => {
      if (user && shouldFetch.subscription_payment_failed_funnel_step && subscriptionFailedFunnelId) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel-step/${trigger}/${subscriptionFailedFunnelId}`;
      }
      return null;
    };
    $[58] = shouldFetch.subscription_payment_failed_funnel_step;
    $[59] = subscriptionFailedFunnelId;
    $[60] = trigger;
    $[61] = user;
    $[62] = t17;
  } else {
    t17 = $[62];
  }
  const {
    data: funnelStepsSubscriptionPaymentFailed
  } = useSWR(t17, baseFetcher);
  let t18;
  if ($[63] !== shouldFetch.registered_to_webinar || $[64] !== trigger || $[65] !== user) {
    t18 = () => {
      if (user && shouldFetch.registered_to_webinar && trigger === AutomationRuleTriggersEnum.registered_to_webinar) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/funnel/${trigger}`;
      }
      return null;
    };
    $[63] = shouldFetch.registered_to_webinar;
    $[64] = trigger;
    $[65] = user;
    $[66] = t18;
  } else {
    t18 = $[66];
  }
  const {
    data: funnelsWebinar
  } = useSWR(t18, baseFetcher);
  let t19;
  if ($[67] !== shouldFetch.registered_to_webinar_funnel_step || $[68] !== user || $[69] !== webinarFunnelId) {
    t19 = () => {
      if (user && shouldFetch.registered_to_webinar_funnel_step && webinarFunnelId) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/webinar/${webinarFunnelId}`;
      }
      return null;
    };
    $[67] = shouldFetch.registered_to_webinar_funnel_step;
    $[68] = user;
    $[69] = webinarFunnelId;
    $[70] = t19;
  } else {
    t19 = $[70];
  }
  const {
    data: webinars
  } = useSWR(t19, baseFetcher);
  let t20;
  if ($[71] !== shouldFetch.course || $[72] !== user) {
    t20 = () => user && shouldFetch.course && [`${AUTOMATION_RULES_FILTER_API}/trigger-type/course`, ...coursesDependencies];
    $[71] = shouldFetch.course;
    $[72] = user;
    $[73] = t20;
  } else {
    t20 = $[73];
  }
  const {
    data: courses
  } = useControlledSwr(t20, baseFetcher);
  let t21;
  if ($[74] !== shouldFetch.module || $[75] !== triggerCourseId || $[76] !== user) {
    t21 = () => user && shouldFetch.module && triggerCourseId && [`${AUTOMATION_RULES_FILTER_API}/trigger-type/membership/${triggerCourseId}/modules`, RequestModuleEnum.MembershipLightCourseCurriculum, RequestModuleEnum.MembershipCourseCurriculum];
    $[74] = shouldFetch.module;
    $[75] = triggerCourseId;
    $[76] = user;
    $[77] = t21;
  } else {
    t21 = $[77];
  }
  const {
    data: modules
  } = useControlledSwr(t21, baseFetcher);
  let t22;
  if ($[78] !== shouldFetch.lecture || $[79] !== triggerModuleId || $[80] !== user) {
    t22 = () => user && shouldFetch.lecture && triggerModuleId && [`${AUTOMATION_RULES_FILTER_API}/trigger-type/membership/${triggerModuleId}/lectures`, RequestModuleEnum.MembershipCourseLecture];
    $[78] = shouldFetch.lecture;
    $[79] = triggerModuleId;
    $[80] = user;
    $[81] = t22;
  } else {
    t22 = $[81];
  }
  const {
    data: lectures
  } = useControlledSwr(t22, baseFetcher);
  const {
    courseBundlesListAll
  } = useCourseBundlesListAll(shouldFetch.enrolled_in_course_bundle);
  const {
    campaignsList
  } = useCampaignsList(shouldFetch.campaign_completed);
  let t23;
  if ($[82] !== shouldFetch.enrolled_in_community || $[83] !== user) {
    t23 = () => {
      if (user && shouldFetch.enrolled_in_community) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/community`;
      }
      return null;
    };
    $[82] = shouldFetch.enrolled_in_community;
    $[83] = user;
    $[84] = t23;
  } else {
    t23 = $[84];
  }
  const {
    data: communities
  } = useSWR(t23, baseFetcher);
  let t24;
  if ($[85] !== shouldFetch.email || $[86] !== user) {
    t24 = () => {
      if (user && shouldFetch.email) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/email-link-clicked`;
      }
      return null;
    };
    $[85] = shouldFetch.email;
    $[86] = user;
    $[87] = t24;
  } else {
    t24 = $[87];
  }
  const {
    data: emails
  } = useSWR(t24, emailFetcher);
  let t25;
  if ($[88] !== shouldFetch.email_link || $[89] !== triggerMailingId || $[90] !== user) {
    t25 = () => {
      if (user && shouldFetch.email_link && triggerMailingId) {
        return `${AUTOMATION_RULES_FILTER_API}/trigger-type/mailing/${triggerMailingId}/link-clicked`;
      }
      return null;
    };
    $[88] = shouldFetch.email_link;
    $[89] = triggerMailingId;
    $[90] = user;
    $[91] = t25;
  } else {
    t25 = $[91];
  }
  const {
    data: emailLinks
  } = useSWR(t25, emailLinkFetcher);
  const {
    data: stores
  } = useStoreWithOptinItemsList(shouldFetch.digital_store_form_subscribed);
  const {
    data: digitalStoreOptIns
  } = useStoreOptinItemsList(triggerDigitalStoreId, shouldFetch.digital_store_form_subscribed);
  const {
    myEvents: events
  } = useMyEvents(shouldFetch.booking_created);
  const {
    websiteListAll
  } = useWebsiteListAll(shouldFetch.website_form_subscribed);
  const {
    websitePageListAll
  } = useWebsitePageListAll(triggerWebsiteId, shouldFetch.website_form_subscribed);
  const t26 = tags?.items;
  let t27;
  if ($[92] !== t26) {
    t27 = getData(t26);
    $[92] = t26;
    $[93] = t27;
  } else {
    t27 = $[93];
  }
  let t28;
  if ($[94] !== campaignsList) {
    t28 = geDataFromApiData(campaignsList);
    $[94] = campaignsList;
    $[95] = t28;
  } else {
    t28 = $[95];
  }
  let t29;
  if ($[96] !== blogs) {
    t29 = getData(blogs);
    $[96] = blogs;
    $[97] = t29;
  } else {
    t29 = $[97];
  }
  let t30;
  if ($[98] !== blogs) {
    t30 = getBlogEntityData(blogs);
    $[98] = blogs;
    $[99] = t30;
  } else {
    t30 = $[99];
  }
  let t31;
  if ($[100] !== blogPages) {
    t31 = getData(blogPages);
    $[100] = blogPages;
    $[101] = t31;
  } else {
    t31 = $[101];
  }
  let t32;
  if ($[102] !== blogPosts) {
    t32 = getData(blogPosts);
    $[102] = blogPosts;
    $[103] = t32;
  } else {
    t32 = $[103];
  }
  let t33;
  if ($[104] !== funnelsFormSubscribe) {
    t33 = getData(funnelsFormSubscribe);
    $[104] = funnelsFormSubscribe;
    $[105] = t33;
  } else {
    t33 = $[105];
  }
  let t34;
  if ($[106] !== funnelStepsFormSubscribe) {
    t34 = getData(funnelStepsFormSubscribe);
    $[106] = funnelStepsFormSubscribe;
    $[107] = t34;
  } else {
    t34 = $[107];
  }
  let t35;
  if ($[108] !== funnelsNewSale) {
    t35 = getData(funnelsNewSale);
    $[108] = funnelsNewSale;
    $[109] = t35;
  } else {
    t35 = $[109];
  }
  let t36;
  if ($[110] !== funnelStepsNewSale) {
    t36 = getData(funnelStepsNewSale);
    $[110] = funnelStepsNewSale;
    $[111] = t36;
  } else {
    t36 = $[111];
  }
  let t37;
  if ($[112] !== funnelsSaleCanceled) {
    t37 = getData(funnelsSaleCanceled);
    $[112] = funnelsSaleCanceled;
    $[113] = t37;
  } else {
    t37 = $[113];
  }
  let t38;
  if ($[114] !== funnelStepsSaleCanceled) {
    t38 = getData(funnelStepsSaleCanceled);
    $[114] = funnelStepsSaleCanceled;
    $[115] = t38;
  } else {
    t38 = $[115];
  }
  let t39;
  if ($[116] !== funnelsPageVisited) {
    t39 = getData(funnelsPageVisited);
    $[116] = funnelsPageVisited;
    $[117] = t39;
  } else {
    t39 = $[117];
  }
  let t40;
  if ($[118] !== funnelStepsPageVisited) {
    t40 = getData(funnelStepsPageVisited);
    $[118] = funnelStepsPageVisited;
    $[119] = t40;
  } else {
    t40 = $[119];
  }
  let t41;
  if ($[120] !== funnelsWebinar) {
    t41 = getData(funnelsWebinar);
    $[120] = funnelsWebinar;
    $[121] = t41;
  } else {
    t41 = $[121];
  }
  let t42;
  if ($[122] !== webinars) {
    t42 = getData(webinars);
    $[122] = webinars;
    $[123] = t42;
  } else {
    t42 = $[123];
  }
  let t43;
  if ($[124] !== courses) {
    t43 = getData(courses);
    $[124] = courses;
    $[125] = t43;
  } else {
    t43 = $[125];
  }
  let t44;
  if ($[126] !== modules) {
    t44 = getData(modules);
    $[126] = modules;
    $[127] = t44;
  } else {
    t44 = $[127];
  }
  let t45;
  if ($[128] !== lectures) {
    t45 = getData(lectures);
    $[128] = lectures;
    $[129] = t45;
  } else {
    t45 = $[129];
  }
  let t46;
  if ($[130] !== courseBundlesListAll) {
    t46 = geDataFromApiData(courseBundlesListAll);
    $[130] = courseBundlesListAll;
    $[131] = t46;
  } else {
    t46 = $[131];
  }
  let t47;
  if ($[132] !== communities) {
    t47 = getData(communities);
    $[132] = communities;
    $[133] = t47;
  } else {
    t47 = $[133];
  }
  let t48;
  if ($[134] !== emails) {
    t48 = emails?.map(_temp);
    $[134] = emails;
    $[135] = t48;
  } else {
    t48 = $[135];
  }
  let t49;
  if ($[136] !== emailLinks || $[137] !== t) {
    t49 = emailLinks?.map(el_0 => ({
      id: el_0.id,
      caption: getClickedLinkCaption(t, el_0.type, el_0.displayLinkName),
      customCaption: getClickedLinkCustomCaption(t, el_0.type, el_0.displayLinkName)
    }));
    $[136] = emailLinks;
    $[137] = t;
    $[138] = t49;
  } else {
    t49 = $[138];
  }
  let t50;
  if ($[139] !== funnelsSubscriptionPaymentFailed) {
    t50 = getData(funnelsSubscriptionPaymentFailed);
    $[139] = funnelsSubscriptionPaymentFailed;
    $[140] = t50;
  } else {
    t50 = $[140];
  }
  let t51;
  if ($[141] !== funnelStepsSubscriptionPaymentFailed) {
    t51 = getData(funnelStepsSubscriptionPaymentFailed);
    $[141] = funnelStepsSubscriptionPaymentFailed;
    $[142] = t51;
  } else {
    t51 = $[142];
  }
  let t52;
  if ($[143] !== stores) {
    t52 = getData(stores);
    $[143] = stores;
    $[144] = t52;
  } else {
    t52 = $[144];
  }
  let t53;
  if ($[145] !== digitalStoreOptIns) {
    t53 = digitalStoreOptIns?.map(_temp2);
    $[145] = digitalStoreOptIns;
    $[146] = t53;
  } else {
    t53 = $[146];
  }
  let t54;
  if ($[147] !== events) {
    t54 = getData(events);
    $[147] = events;
    $[148] = t54;
  } else {
    t54 = $[148];
  }
  let t55;
  if ($[149] !== websiteListAll) {
    t55 = getData(websiteListAll);
    $[149] = websiteListAll;
    $[150] = t55;
  } else {
    t55 = $[150];
  }
  let t56;
  if ($[151] !== websitePageListAll) {
    t56 = websitePageListAll?.map(_temp3);
    $[151] = websitePageListAll;
    $[152] = t56;
  } else {
    t56 = $[152];
  }
  let t57;
  if ($[153] !== t27 || $[154] !== t28 || $[155] !== t29 || $[156] !== t30 || $[157] !== t31 || $[158] !== t32 || $[159] !== t33 || $[160] !== t34 || $[161] !== t35 || $[162] !== t36 || $[163] !== t37 || $[164] !== t38 || $[165] !== t39 || $[166] !== t40 || $[167] !== t41 || $[168] !== t42 || $[169] !== t43 || $[170] !== t44 || $[171] !== t45 || $[172] !== t46 || $[173] !== t47 || $[174] !== t48 || $[175] !== t49 || $[176] !== t50 || $[177] !== t51 || $[178] !== t52 || $[179] !== t53 || $[180] !== t54 || $[181] !== t55 || $[182] !== t56) {
    t57 = {
      triggersData: {
        tagData: t27,
        campaignData: t28,
        blogData: t29,
        blogEntityData: t30,
        blogPagesData: t31,
        blogPostsData: t32,
        funnelsFormSubscribeData: t33,
        funnelStepsFormSubscribeData: t34,
        funnelsNewSaleData: t35,
        funnelStepsNewSaleData: t36,
        funnelsSaleCanceledData: t37,
        funnelStepsSaleCanceledData: t38,
        funnelsPageVisitedData: t39,
        funnelStepsPageVisitedData: t40,
        funnelsWebinarData: t41,
        webinarData: t42,
        courseData: t43,
        moduleData: t44,
        lectureData: t45,
        courseBundleData: t46,
        communityData: t47,
        emailData: t48,
        emailLinksData: t49,
        funnelsSubscriptionPaymentFailedData: t50,
        funnelStepsSubscriptionPaymentFailedData: t51,
        digitalStoresData: t52,
        digitalStoreOptInsData: t53,
        eventsData: t54,
        websiteData: t55,
        websitePageData: t56
      },
      setShouldFetch
    };
    $[153] = t27;
    $[154] = t28;
    $[155] = t29;
    $[156] = t30;
    $[157] = t31;
    $[158] = t32;
    $[159] = t33;
    $[160] = t34;
    $[161] = t35;
    $[162] = t36;
    $[163] = t37;
    $[164] = t38;
    $[165] = t39;
    $[166] = t40;
    $[167] = t41;
    $[168] = t42;
    $[169] = t43;
    $[170] = t44;
    $[171] = t45;
    $[172] = t46;
    $[173] = t47;
    $[174] = t48;
    $[175] = t49;
    $[176] = t50;
    $[177] = t51;
    $[178] = t52;
    $[179] = t53;
    $[180] = t54;
    $[181] = t55;
    $[182] = t56;
    $[183] = t57;
  } else {
    t57 = $[183];
  }
  return t57;
}
function _temp3(el_2) {
  return {
    id: el_2.pageContentId,
    caption: el_2.name,
    group: el_2.locale
  };
}
function _temp2(el_1) {
  return {
    id: el_1.id,
    caption: el_1.title
  };
}
function _temp(el) {
  return {
    id: el.id,
    caption: el.subject
  };
}